import { render, staticRenderFns } from "./NoisePage.vue?vue&type=template&id=07f82e67"
import script from "./noise.js?vue&type=script&lang=js&external"
export * from "./noise.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports